import { render, staticRenderFns } from "./techprocessesEdit.vue?vue&type=template&id=38903cc8&scoped=true&"
import script from "./techprocessesEdit.vue?vue&type=script&lang=js&"
export * from "./techprocessesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38903cc8",
  null
  
)

export default component.exports